module.exports = __webpack_public_path__ + "zm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/zm.svg
// module id = 1153
// module chunks = 0